export const TEST_ID = 'lifecyclePill';
